module.exports = __webpack_public_path__ + "static/media/8.841e4ec8.png";